/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCodeOff = createReactComponent("outline", "code-off", "IconCodeOff", [["path", { "d": "M7 8l-4 4l4 4", "key": "svg-0" }], ["path", { "d": "M17 8l4 4l-2.5 2.5", "key": "svg-1" }], ["path", { "d": "M14 4l-1.201 4.805m-.802 3.207l-2 7.988", "key": "svg-2" }], ["path", { "d": "M3 3l18 18", "key": "svg-3" }]]);

export { IconCodeOff as default };
//# sourceMappingURL=IconCodeOff.mjs.map
